import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {searchResponse} from 'constants/enums';

const searchCategory = Object.values(searchResponse);

export type Suggestions = {
  id: number;
  name: string;
  category: (typeof searchCategory)[number];
  type: keyof typeof searchResponse;
  metadata: {
    proj_id: number;
    name: string;
  };
};

type initialStateType = {
  searchSuggestions: Suggestions[];
  totalPages?: number;
  currentPage?: number;
  nextPage?: number | null;
  errorDashboard: boolean | string;
  successDashboard: boolean | string;
  isLoading: boolean;
};

const initialState: initialStateType = {
  isLoading: false,
  searchSuggestions: [],
  currentPage: 0,
  nextPage: null,
  totalPages: 0,
  errorDashboard: false,
  successDashboard: false,
};

/**
 * type for smart search
 */

export type smartSearchRequestParams = {
  search_text: string;
  page?: number;
};

export type smartSearchSuccessResponse = {
  status_code: string;
  data: {
    suggestions: [];
    current_page: number;
    next_page: number | null;
    total_page: number;
  };
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    smartSearchRequest(state, action: PayloadAction<smartSearchRequestParams>) {
      state.isLoading = true;
    },
    smartSearchFailure(state, action: PayloadAction<string | boolean>) {
      state.isLoading = false;
      state.errorDashboard = action.payload;
    },
    smartSearchSuccess(
      state,
      action: PayloadAction<smartSearchSuccessResponse>,
    ) {
      state.isLoading = false;
      state.successDashboard = action.payload.status_code;
      state.totalPages = action.payload.data.total_page;
      state.currentPage = action.payload.data.current_page;
      state.nextPage = action.payload.data.next_page;
      state.searchSuggestions = action.payload.data.suggestions;
    },

    resetMessage(state) {
      state.errorDashboard = false;
      state.successDashboard = false;
    },
  },
});

export const {
  resetMessage,
  smartSearchFailure,
  smartSearchRequest,
  smartSearchSuccess,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
